<template>
  <div>
    <div class="near-black ph4 pv4 bb b--black-10 flex flex-wrap items-center w-100">
      <div class="center mw10 flex flex-wrap items-center">
        <div>
          <h1 class="avenir fw6 f3 lh-copy">Are you a creative professional? Request an invite to join the AVVAY Pro community.</h1>
        </div>
        <div class="ph4-ns">
          <a href="https://pro.avvay.com/" class="dib white bg-teal hover-bg-teal link fw6 pa3 ph4 br2 f3">Request Invite</a>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap">
      <!-- Left Column (Desktop only) -->
      <div class="w-100 w-25-ns pa4 br b--black-10 dn db-ns dn-m">
        <div class="flex justify-between items-center pv2">
          <h2 class="f2 mv0 pv0 fw6 near-black avenir">Filter by</h2>
          <!-- RESET FILTERS -->
          <div class="v-mid" v-if="anyFacetsSelected"><a href="/pro/search/user" class="teal hover-teal f4 fw6" @click.prevent="clearAllSelectedFacets">Reset</a></div>
        </div>
        <!-- SELECTED FILTERS -->
        <div class="pv2">
          <h3 class="avenir f4 fw6" v-if="anyFacetsSelected">Selected Filters</h3>
          <div v-for="facet in selectedFacets"
               class="dib pa2 lh-copy ph3 br-pill ba b--teal teal cursor hover-bg-white f5 ma1 bg-teal-10"
               @click.prevent="toggleFacetSearch(facet)"
          >
            <strong>{{facet.name}} <img src="/img/tag-delete.svg" alt="Remove Tag"></strong>
          </div>
        </div>
        <!-- AVAILABLE STATE FACETS -->
        <div class="pv2">
          <a href="#" @click.prevent="toggleStateFacetSelector" class="hover-bg-black-10 bg-near-white pa2 ph3 br2 flex flex-wrap items-center justify-between">
            <div><h3 class="avenir mv0 pv0 f4 fw6 near-black">State</h3></div>
            <div>
              <img v-if="!stateFacetSelectorShowing" src="/img/control-plus.svg" alt="Expand">
              <img v-if="stateFacetSelectorShowing" src="/img/control-minus.svg" alt="Minimize">
            </div>
          </a>
          <div v-show="stateFacetSelectorShowing" class="pv3">
            <div v-for="facet in facets.states"
                 class="dib cursor hover-bg-near-white bg-animate pa2 lh-copy ph3 br-pill ba b--black-10 f5 fw2 ma1"
                 :class="facet.selected ? 'bg-teal-10 teal fw4 ba b--teal' : 'bg-white'"
                 @click.prevent="toggleFacetSearch(facet)"
            >
              <strong>{{facet.name}}</strong> <span class="f5">{{facet.count}}</span>
            </div>
          </div>
        </div>
        <!-- AVAILABLE CITY-STATES FACETS -->
        <div v-if="facets.cityStates" class="pv2">
          <a href="#" @click.prevent="toggleCityStateFacetSelector" class="hover-bg-black-10 bg-near-white pa2 ph3 br2 flex flex-wrap items-center justify-between">
            <div><h3 class="avenir mv0 pv0 f4 fw6 near-black">City</h3></div>
            <div>
              <img v-if="!cityStateFacetSelectorShowing" src="/img/control-plus.svg" alt="Expand">
              <img v-if="cityStateFacetSelectorShowing" src="/img/control-minus.svg" alt="Minimize">
            </div>
          </a>
          <div v-show="cityStateFacetSelectorShowing" class="pv3">
            <div v-for="facet in facets.cityStates"
                 class="dib cursor hover-bg-near-white bg-animate pa2 lh-copy ph3 br-pill ba b--black-10 f5 fw2 ma1"
                 :class="facet.selected ? 'bg-teal-10 teal fw4 ba b--teal' : 'bg-white'"
                 @click.prevent="toggleFacetSearch(facet)"
            >
              <strong>{{facet.name}}</strong> <span class="f5">{{facet.count}}</span>
            </div>
          </div>
        </div>
        <!-- AVAILABLE JOB TITLE FACETS -->
        <div class="pv2">
          <a href="#" @click.prevent="toggleJobTitleFacetSelector" class="hover-bg-black-10 bg-near-white pa2 ph3 br2 flex flex-wrap items-center justify-between">
            <div><h3 class="avenir mv0 pv0 f4 fw6 near-black">Occupation</h3></div>
            <div>
              <img v-if="!jobTitleFacetSelectorShowing" src="/img/control-plus.svg" alt="Expand">
              <img v-if="jobTitleFacetSelectorShowing" src="/img/control-minus.svg" alt="Minimize">
            </div>
          </a>
          <div v-show="jobTitleFacetSelectorShowing" class="pv3">
            <div v-for="facet in facets.jobTitles"
                 class="dib cursor hover-bg-near-white bg-animate pa2 lh-copy ph3 br-pill ba b--black-10 f5 fw2 ma1"
                 :class="facet.selected ? 'bg-teal-10 teal fw4 ba b--teal' : 'bg-white'"
                 @click.prevent="toggleFacetSearch(facet)"
            >
              <strong>{{facet.name}}</strong> <span class="f5">{{facet.count}}</span>
            </div>
          </div>
        </div>
        <!-- AVAILABLE TAG FACETS -->
        <div class="pv3">
          <a href="#" @click.prevent="toggleTagFacetSelector" class="hover-bg-black-10 bg-near-white pa2 ph3 br2 flex flex-wrap items-center justify-between">
            <h3 class="avenir mv0 pv0 f4 fw6 near-black">Tags</h3>
            <div>
              <img v-if="!tagFacetSelectorShowing" src="/img/control-plus.svg" alt="Expand">
              <img v-if="tagFacetSelectorShowing" src="/img/control-minus.svg" alt="Minimize">
            </div>
          </a>
          <div v-show="tagFacetSelectorShowing" class="pv3">
            <div v-for="facet in facets.tags"
                 class="dib cursor hover-bg-near-white bg-animate pa2 lh-copy ph3 br-pill ba b--black-10 f5 fw2 ma1"
                 :class="facet.selected ? 'bg-teal-10 teal fw4 ba b--teal' : 'bg-white'"
                 @click.prevent="toggleFacetSearch(facet)"
            >
              <strong>{{facet.name}}</strong> <span class="f5">{{facet.count}}</span>
            </div>
          </div>
          </a>
        </div>
      </div>
      <!-- Right Column -->
      <div class="w-100 w-100-m w-75-ns">
        <div class="">
          <div class="bb b--black-10 pa0">
            <ul class="list pt3 pt3-m pt5-ns mv0 pl4 pl4-m pl5-ns">
              <!-- show / hide search small screen -->
              <li class="ma0 pa0 mr3 mr4-m mr0-ns f3 fw6 dib">
                <div class="dn-ns db-m">
                  <a v-if="!mobileSearchFiltersShowing" href="#" @click.prevent="showMobileSearchFilters()" class="animated fadeIn pro-search-button">
                    <img src="/img/search-icon.png" alt="Search" width="48">
                  </a>
                  <a v-if="mobileSearchFiltersShowing" href="#" @click.prevent="hideMobileSearchFilters()" class="animated fadeIn pro-search-button">
                    <img src="/img/search-back-icon.png" alt="Search" width="48">
                  </a>
                </div>
              </li>
              <li class="ma0 pa0 mr4 mr4-m mr5-ns f3 fw6 dib">
                <a href="/pro/search/project" class="fw7 near-black hover-silver pb3 dib bb b--black pro-search-tab" role="tab">Posts</a>
              </li>
              <li class="ma0 pa0 mr4 mr4-m mr5-ns f3 fw6 dib">
                <a href="/pro/search/user" class="fw4 near-black hover-silver pb3 dib pro-search-tab" role="tab">Pros</a>
              </li>
            </ul>
          </div>
          <div class="pa0 pa0-m pa5-ns pv3">
            <!-- Search fields (small screen) -->
            <transition name="fade">
              <div class="w-100 pro-search" v-if="mobileSearchFiltersShowing">
                <div class="db db-m dn-ns ph4 pb4 bb b--black-10">
                  <div class="flex justify-between items-center pv2">
                    <h3 class="f2 mv0 pv0 fw6 near-black avenir">Filter by</h3>
                    <!-- RESET FILTERS -->
                    <div class="v-mid" v-if="anyFacetsSelected"><a href="/pro/search/user" class="teal hover-teal f4 fw6" @click.prevent="clearAllSelectedFacets">Reset</a></div>
                  </div>
                  <!-- SELECTED FILTERS -->
                  <div v-if="anyFacetsSelected" class="bg-white ba b--black-10 mb4 mt3 br2 pa4">
                    <h3 class="mt0 f3 fw6 near-black avenir">Selected Filters</h3>
                    <div v-for="facet in selectedFacets"
                         class="dib pa2 lh-copy ph3 br-pill ba b--teal teal cursor hover-bg-white f5 ma1 bg-teal-10"
                         @click.prevent="toggleFacetSearch(facet)"
                    >
                      <strong>{{facet.name}} <img src="/img/tag-delete.svg" alt="Remove Tag"></strong>
                    </div>
                  </div>
                  <!-- AVAILABLE STATE FACETS -->
                  <div class="pv2">
                    <a href="#" @click.prevent="toggleStateFacetSelector" class="hover-bg-black-10 bg-near-white pa3 br2 flex flex-wrap items-center justify-between">
                      <div><h3 class="avenir mv0 pv0 f3 fw6 near-black">State</h3></div>
                      <div>
                        <img v-if="!stateFacetSelectorShowing" src="/img/control-plus.svg">
                        <img v-if="stateFacetSelectorShowing" src="/img/control-minus.svg">
                      </div>
                    </a>
                    <div v-show="stateFacetSelectorShowing" class="pv3">
                      <div v-for="facet in facets.states"
                           class="dib cursor hover-bg-near-white bg-animate pa2 lh-copy ph3 br-pill ba b--black-10 f5 fw2 ma1"
                           :class="facet.selected ? 'bg-teal-10 teal fw4 ba b--teal' : 'bg-white'"
                           @click.prevent="toggleFacetSearch(facet)"
                      >
                        <strong>{{facet.name}}</strong> <span class="f5">{{facet.count}}</span>
                      </div>
                    </div>
                  </div>
                  <!-- AVAILABLE CITY-STATES FACETS -->
                  <div v-if="facets.cityStates" class="pv2">
                    <a href="#" @click.prevent="toggleCityStateFacetSelector" class="hover-bg-black-10 bg-near-white pa3 br2 flex flex-wrap items-center justify-between">
                      <div><h3 class="avenir mv0 pv0 f3 fw6 near-black">City</h3></div>
                      <div>
                        <img v-if="!cityStateFacetSelectorShowing" src="/img/control-plus.svg" alt="Expand">
                        <img v-if="cityStateFacetSelectorShowing" src="/img/control-minus.svg" alt="Minimize">
                      </div>
                    </a>
                    <div v-show="cityStateFacetSelectorShowing" class="pv3">
                      <div v-for="facet in facets.cityStates"
                           class="dib cursor hover-bg-near-white bg-animate pa2 lh-copy ph3 br-pill ba b--black-10 f5 fw2 ma1"
                           :class="facet.selected ? 'bg-teal-10 teal fw4 ba b--teal' : 'bg-white'"
                           @click.prevent="toggleFacetSearch(facet)"
                      >
                        <strong>{{facet.name}}</strong> <span class="f5">{{facet.count}}</span>
                      </div>
                    </div>
                  </div>
                  <!-- AVAILABLE JOB TITLE FACETS -->
                  <div class="pv2">
                    <a href="#" @click.prevent="toggleJobTitleFacetSelector" class="hover-bg-black-10 bg-near-white pa3 br2 flex flex-wrap items-center justify-between">
                      <div><h3 class="avenir mv0 pv0 f3 fw6 near-black">Occupation</h3></div>
                      <div>
                        <img v-if="!jobTitleFacetSelectorShowing" src="/img/control-plus.svg" alt="Expand">
                        <img v-if="jobTitleFacetSelectorShowing" src="/img/control-minus.svg" alt="Minimize">
                      </div>
                    </a>
                    <div v-show="jobTitleFacetSelectorShowing" class="pv3">
                      <div v-for="facet in facets.jobTitles"
                           class="dib cursor hover-bg-near-white bg-animate pa2 lh-copy ph3 br-pill ba b--black-10 f5 fw2 ma1"
                           :class="facet.selected ? 'bg-teal-10 teal fw4 ba b--teal' : 'bg-white'"
                           @click.prevent="toggleFacetSearch(facet)"
                      >
                        <strong>{{facet.name}}</strong> <span class="f5">{{facet.count}}</span>
                      </div>
                    </div>
                  </div>
                  <!-- AVAILABLE TAG FACETS -->
                  <div class="pv3">
                    <a href="#" @click.prevent="toggleTagFacetSelector" class="hover-bg-black-10 bg-near-white pa3 br2 flex flex-wrap items-center justify-between">
                      <h3 class="avenir mv0 pv0 f3 fw6 near-black">Tags</h3>
                      <div>
                        <img v-if="!tagFacetSelectorShowing" src="/img/control-plus.svg" alt="Expand">
                        <img v-if="tagFacetSelectorShowing" src="/img/control-minus.svg" alt="Minimize">
                      </div>
                    </a>
                    <div v-show="tagFacetSelectorShowing" class="pv3">
                      <div v-for="facet in facets.tags"
                           class="dib cursor hover-bg-near-white bg-animate pa2 lh-copy ph3 br-pill ba b--black-10 f5 fw2 ma1"
                           :class="facet.selected ? 'bg-teal-10 teal fw4 ba b--teal' : 'bg-white'"
                           @click.prevent="toggleFacetSearch(facet)"
                      >
                        <strong>{{facet.name}}</strong> <span class="f5">{{facet.count}}</span>
                      </div>
                    </div>
                    </a>
                  </div>
                </div>
              </div>
            </transition>
            <div class="" id="pro-posts-search">
              <h3 class="f1 f1-m f-subheadline-ns fw6 avenir ml4 ml4-m ml0-ns mt5-m mt0-ns">Posts</h3>
              <h4 class="f3 fw6 pb2 pb4-ns mid-gray ml4 ml4-m ml0-ns">
                &nbsp;<span v-if="anyFacetsSelected">Show posts filtered by</span>
                <div v-for="facet in selectedFacets"
                     class="dib pa2 lh-copy ph3 br-pill ba b--teal teal cursor hover-bg-white f5 ma1 bg-teal-10"
                     @click.prevent="toggleFacetSearch(facet)"
                >
                  <strong>{{facet.name}} <img src="/img/tag-delete.svg" alt="Remove Tag"></strong>
                </div>
              </h4>
              <div class="grid center pa0">
                <div v-masonry
                     transition-duration="0.0s"
                     item-selector=".item"
                     column-width="280"
                     class="center"
                     fit-width="true"
                     gutter="20">
                  <!-- setting :key to concatenation of db.id + index order so that sort order changes are reactive -->
                  <div v-masonry-tile class="grid-item item ph2" :key="searchResult.id + '_' + idx" v-for="(searchResult, idx) in searchResults">
                    <!-- block item markup -->
                    <pro-project-card
                        :project="searchResult"
                        :show-buttons="false"
                        profile-link-target="_blank">
                    </pro-project-card>
                  </div>
                </div>
                <div class="pa3 pv4 db db-m dn-ns">
                  <a v-if="canLoadMore" @click.prevent="loadMore" class="db bg-teal hover-bg-teal white f3 fw6 tc cursor br2 pa3">View more posts</a>
                </div>
              </div>
            </div>
            <div class="tab-pane fade in" id="pro-users-search">
              <!--empty --->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import _ from 'lodash'
    import proProjectCard from '../../../project/components/ProProjectCard'
    import searchService from '../../../../../api/ProjectService'
    import utils from '../../../../../api/Utils'
    import { mapState, mapGetters } from 'vuex'

    export default {
        name: 'ProProjectSearch',
        components: {
            proProjectCard,
        },

        computed: {
            ...mapState(['initialSearchResults', 'currentUser']),
            ...mapGetters(['userHasRolePro']),
            anyFacetsSelected() {
                return !_.isEmpty(this.selectedFacets);
            },
            selectedFacets() {
                return _.concat(this.selectedTags, this.selectedStates, this.selectedCityStates, this.selectedJobTitles);
            },
            //TAGS
            selectedTags() {
                return _.filter(this.facets.tags, tag => tag.selected);
            },

            //STATES
            selectedStates() {
                return _.filter(this.facets.states, state => state.selected);
            },

            //CITIES
            selectedCityStates() {
                return _.filter(this.facets.cityStates, cityState => cityState.selected);
            },

            //JOB TITLES
            selectedJobTitles() {
                return _.filter(this.facets.jobTitles, jobTitle => jobTitle.selected);
            },

            query() {
                const obj = {
                    "tags": _.map(this.selectedTags, 'name'),
                    "states": _.map(this.selectedStates, 'name'),
                    "cityStates": _.map(this.selectedCityStates, 'name'),
                    "jobTitles": _.map(this.selectedJobTitles, 'name')
                };

                return utils.objToQueryStr(obj, false);
            },

            canLoadMore() {
                return this.pageNumber < this.totalPages - 1
            }
        },

        data() {
            return {
                facets: {
                    tags: [],
                    states: [],
                    cityStates: [],
                    jobTitles: [],
                },
                searchResults: [],
                pageNumber: 0,
                totalPages: 0,
                mobileSearchFiltersShowing: false,
                tagFacetSelectorShowing: false,
                stateFacetSelectorShowing: false,
                cityStateFacetSelectorShowing: false,
                jobTitleFacetSelectorShowing: false,

            }
        },

        methods: {
            initInfiniteScroll() {
                window.onscroll = () => {
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    let bottomOfWindow = scrollTop + window.innerHeight === document.documentElement.offsetHeight;
                    if (bottomOfWindow) {
                        if(this.canLoadMore) {
                            this.loadMore();
                        } else {
                            console.log("that's all folks");
                        }
                    }
                };
            },
            loadMore() {
                this.pageNumber++;
                let query = this.query + '&page=' + this.pageNumber;
                searchService.search(query, true).then(response => {
                    this.searchResults.push(...response.data.items);
                });
            },
            search() {
                searchService.search(this.query).then(response => {
                    this.displaySearchResults(response.data);
                });
            },

            extractFacets(facets, queryVals) {
               return _.forEach(facets, facet => { //set tag facets and preserve selection state
                    const selected = !!_.find(queryVals, val => val === facet.name);
                    this.$set(facet, 'selected', selected);
                });
            },

            displaySearchResults(results) {
                this.pageNumber = 0;
                this.totalPages = results.totalPages;

                this.searchResults = results.items;

                this.facets.tags = this.extractFacets(results.facets.tags, results.query.tags);
                this.facets.states = this.extractFacets(results.facets.states, results.query.states);
                this.facets.cityStates = this.extractFacets(results.facets.cityStates, results.query.cityStates);
                this.facets.jobTitles = this.extractFacets(results.facets.jobTitles, results.query.jobTitles);
            },

            toggleFacetSearch(facet) {
                facet.selected = !facet.selected;
                this.search();
            },

            toggleStateFacetSelector(){
                this.stateFacetSelectorShowing = !this.stateFacetSelectorShowing;
            },

            toggleTagFacetSelector(){
                this.tagFacetSelectorShowing = !this.tagFacetSelectorShowing;
            },

            toggleCityStateFacetSelector(){
                this.cityStateFacetSelectorShowing = !this.cityStateFacetSelectorShowing;
            },

            toggleJobTitleFacetSelector(){
                this.jobTitleFacetSelectorShowing = !this.jobTitleFacetSelectorShowing;
            },

            showMobileSearchFilters(){
                this.mobileSearchFiltersShowing = true;
            },

            hideMobileSearchFilters(){
                this.mobileSearchFiltersShowing = false;
            },

            clearAllSelectedFacets(){
                this.deselectAllSelected(this.facets.tags);
                this.deselectAllSelected(this.facets.states);
                this.deselectAllSelected(this.facets.cityStates);
                this.deselectAllSelected(this.facets.jobTitles);
                this.search();
            },

            deselectAllSelected(facetCollection){
                _.each(facetCollection, facet => {
                    facet.selected = false;
                    return true; // have to return true or it will exit after the first
                });
            }

        },
        created() {
            this.displaySearchResults(this.initialSearchResults);
            this.initInfiniteScroll();
        }
    }
</script>

<!-- styles for this component -->
<style scoped>
  .nav-tabs li a {
    background: transparent;
    border: none;
    font-weight: normal;
  }

  .nav-tabs li a:hover {
    color: #333;
  }

  .nav-tabs li.active>a {
    font-weight: bold;
  }

  .nav-tabs>li.active>a,
  .nav-tabs>li.active>a:focus,
  .nav-tabs>li.active>a:hover {
    border-bottom: 1px solid #333;
    border-left: none;
    border-right: none;
    border-top: none;
    background: transparent !important;
    cursor: pointer;
    color: #333;
  }

  .nav-tabs>li.active>a:hover {
    background-color: white !important;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/search/project/components/ProProjectSearch.vue